<!--
 * @Author: 仙道
 * @Date: 2022-08-14 14:26:17
 * @LastEditTime: 2024-08-12 13:56:54
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-wf-web/src/views/equipment/account/modules/DeviceDetail.vue
-->
<template>
  <page-layout :breadcrumb="false" :title="deviceData.devName || '-'">
    <div class="page-header-title" slot="action" v-if="deviceVideoList.length > 0">
      <a-icon @click="visibModal" class="action-i" type="video-camera" />
    </div>
    <div class="page-header-content" slot="headerContent">
      <div class="page-avatar flex flex-col">
        <j-image-upload
          :disabled="true"
          bizPath="scott/pic"
          v-if="deviceData.pictureObjId"
          v-model="deviceData.pictureObjId"
        ></j-image-upload>
        <j-image-upload :disabled="true" bizPath="scott/pic" v-model="deviceData.qrcode"></j-image-upload>
      </div>
      <div class="content">
        <a-descriptions :column="3">
          <a-descriptions-item
            :key="index"
            :label="item.name"
            v-for="(item, index) in accountItemTab.filter(item => !item.disabled)"
          >
            <template v-if="item.dict">{{ $filterDictTextByCache(item.dict, item.v) }}</template>
            <!-- <template v-if="item.dict">{{ item.v }}</template> -->
            <template v-else-if="item.k === 'qrcode'">
              <div class="relative">
                <img :src="deviceData.qrcode" preview />
              </div>
            </template>
            <template v-else-if="item.k == 'manuName'">
              <a-button @click="showStatReport(deviceData, 'manuReport', 'manuId')" type="link" v-if="item.v">
                <j-ellipsis :length="10" :value="item.v" />
              </a-button>
            </template>
            <template v-else-if="item.k == 'modelName'">
              <a-button @click="handleDevModalDetail" type="link" v-if="item.v">{{ item.v }}</a-button>
            </template>
            <template v-else-if="item.k == 'runningLife'">{{ `${item.v}天` }}</template>
            <template v-else>{{ item.v }}</template>
          </a-descriptions-item>
        </a-descriptions>

        <!-- <a-button v-if="deviceData.hasVmodel == 1" @click="to3Dpage" style="float:right;" type="link"
          >三维定位>>></a-button
        >-->
      </div>
    </div>

    <div class="c-tabs">
      <a-card :bordered="false">
        <a-tabs v-if="tableLoading">
          <a-tab-pane :key="item.key" :tab="item.tab" v-for="item in componentList">
            <component :deviceData="deviceData" :is="item.views" :query="item.query || item.propsData" @ok="detailOk" />
          </a-tab-pane>
        </a-tabs>
      </a-card>
    </div>

    <dev-model-modal-drawer ref="modalForm"></dev-model-modal-drawer>
    <video-modal @ok="videoModalFormOk" ref="videoModal" />

    <iframe-drawer ref="iframeDrawer"></iframe-drawer>
  </page-layout>
</template>

<script>
  import { getIframesByUrl, getIframesMenuPathBykeyWord } from '@/utils/util'
  import PageLayout from '@/components/page/PageLayout'
  import { mapGetters } from 'vuex'
  import DetailList from '@/components/tools/DetailList'
  import DevModelModalDrawer from '@/views/equipment/account/vue/modules/DevModelModalDrawer'
  import { getAction } from '@/api/manage'
  import VideoModal from '@/components/VideoModal'
  const DetailListItem = DetailList.Item
  export default {
    name: 'DeviceDetail',
    components: {
      PageLayout,
      DetailListItem,
      DetailList,
      DevModelModalDrawer,
      VideoModal
    },
    props: {
      query: {
        type: Object,
        default: () => { }
      }
    },
    // 定义属性
    data () {
      return {
        tableLoading: false,
        deviceVideoList: [],
        activeTabKey: '',
        contentWidth: 'Fluid',
        accountItemTab: [
          {
            name: '设备名称',
            k: 'devName',
            v: '',
            disabled: true
          },
          {
            name: '表号',
            k: 'devTag',
            v: ''
          },
          {
            name: '设备类型',
            k: 'typeName',
            v: ''
          },
          {
            name: '设备状态',
            k: 'serviceStatus',
            type: 'emnu',
            dict: 'dev_life_status'
          },
          {
            name: '负责人',
            k: 'leaderId_dictText',
            v: ''
          },
          {
            name: '投运日期',
            k: 'operationDate',
            v: ''
          },
          {
            name: '生产厂家',
            k: 'manuName',
            v: ''
          },
          {
            name: '设备型号',
            k: 'modelName',
            v: ''
          },
          {
            name: '出厂日期',
            k: 'factoryDate',
            v: ''
          },
          {
            name: '出厂编号',
            k: 'factoryNumber',
            v: ''
          },
          //   {
          //     name: '使用寿命',
          //     k: 'runningLife',
          //     v: ''
          //   }
        ],
        componentList: [
          {
            view: 'MeasuringPoint',
            name: '相关测点',
            path: 'equipment/account/modules/components/MeasuringPoint'
          },
          {
            view: 'AccountParams',
            name: '设备参数',
            path: 'equipment/account/modules/components/AccountParams'
          },
          {
            view: 'BleConfig',
            name: '蓝牙配置',
            path: 'equipment/account/modules/components/BleConfig'
          },
          {
            view: 'IotAlertListForPerson',
            name: '未处理告警',
            path: 'monitor/alert/IotAlertListForPerson'
          },
          {
            view: 'corpPermission',
            name: '使用单位',
            path: 'wf/WfConsumerCorpPermissionList'
          },
          {
            view: 'availHours',
            name: '运行时间',
            path: 'equipment/account/vue/DevAvailHoursList'
          },
          {
            view: 'AccountManual',
            name: '设备手册',
            path: 'equipment/account/modules/components/AccountManual'
          },
          {
            view: 'PendingAlert',
            name: '保养标准',
            path: 'equipment/account/modules/components/PendingAlert'
          }
          // {
          //   view: 'Bpbj',
          //   name: '备件标准',
          //   path: 'equipment/account/modules/components/Bpbj'
          // }
          // {
          //   view: 'Maintenance',
          //   name: '保养标准'
          // },
          // {
          //   view: 'RecordInfo',
          //   name: '履历',
          //   path: 'equipment/account/modules/components/RecordInfo'

          // }
          // 供水流域挂测点
          // 设备型号关联设备类型
          // 设备类型ui改造
        ],
        url: {
          commonManufacturer: '/device/commonManufacturer/selectDropList',
          queryById: '/device/devList/queryDetailById',
          getReportUrl: '/custom/commonOnlReport/list',
          queryVideo: '/video/videoDevice/getDevVideoInfoList',
          getWebViewPanel: '/monitor/iotModelPoints/getWebViewPanel'
        },
        // 制造商
        manuList: [],
        deviceData: {},
        reportUrl: {},
        videoModalShow: false
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters(['']),
      operationType () {
        return this.$route.query.pageType || 'form'
      },
      deviceId () {
        return this.query?.id || this.$route.params.id
      }
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {
      if (this.tableLoading) return
      this.InitData()
      this.Initialize()
      this.InitDeviceVideo()
      const that = this
      getAction(this.url.getReportUrl, { reportGroup: 'drill-ana' }).then(res => {
        if (res.success && res.result) {
          res.result.records.forEach(rep => {
            that.reportUrl[rep.shortName] = rep.url
          })
        }
      })
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () { },
    // 方法集合
    methods: {
      Initialize () {
        const tabs = this.componentList.reduce((arr, cur) => {
          const _cur = {
            propsData: {},
            deviceId: this.deviceId,
            tab: cur.name,
            key: cur.view,
            views: resolve => require([`@/views/${cur.path}.vue`], resolve)
          }
          if (cur.view == 'IotAlertListForPerson') {
            _cur.query = {
              devId: this.deviceId,
              disposal: 0
            }
          }
          arr.push(_cur)
          return arr
        }, [])
        this.componentList = tabs
      },
      async InitDeviceVideo () {
        const res = await getAction(this.url.queryVideo, {
          devId: this.deviceId
        })
        if (res && res.success) {
          this.deviceVideoList = res.result || []
        }
      },
      async InitData () {
        const res = await getAction(this.url.queryById, { id: this.deviceId })
        this.deviceData = res.result
        const itemTab = this.accountItemTab.reduce((pre, cur) => {
          cur.v = res.result[cur.k]
          pre.push(cur)
          return pre
        }, [])
        //  this.accountItemTab = itemTab
        this.tableLoading = true
      },
      detailOk () {
        this.InitData()
      },
      handleDevModalDetail () {
        this.$refs.modalForm.edit({ id: this.deviceData.devTypeId })
        this.$refs.modalForm.title = '详情'
        this.$refs.modalForm.disableSubmit = true
      },
      to3Dpage () {
        const permissionList = this.$store.getters.permissionList
        const _3dpath = getIframesMenuPathBykeyWord(permissionList, 'page=3d')

        getAction(this.url.getWebViewPanel, { bizType: 'dev', bizId: this.deviceData.id }).then(res => {
          if (res.success && res.result) {
            const viewData = res.result.viewData
            const panels = res.result.panels

            const _3diframes = getIframesByUrl('page=3d')
            if (_3diframes.length) {
              const contentWindow = _3diframes[0].contentWindow
              contentWindow.postMessage(
                JSON.stringify({
                  event: 'setView',
                  params: JSON.parse(viewData)
                }),
                '*'
              )
              const panelDataArr = []
              panels &&
                panels.forEach(panel => {
                  panelDataArr.push({
                    name: panel.panelName,
                    code: panel.panelCode,
                    position: typeof panel.position == 'string' ? JSON.parse(panel.position) : panel.position,
                    list: panel.list
                  })
                })
              contentWindow.postMessage(
                JSON.stringify({
                  event: 'showPopup',
                  params: panelDataArr
                }),
                '*'
              )
              this.$router.push({ path: _3dpath })
            } else {
              this.$router.push({ path: _3dpath })
            }
          } else {
            this.$message.warning('非关键设备')
          }
        })
      },
      showStatReport (record, reportKey, key) {
        let url = this.reportUrl[reportKey]
        if (!url) {
          this.$message.warning('未找到统计信息配置')
        }
        if (url.indexOf(`${key}`) > -1) {
          url = url.replace(`\$\{${key}\}`, record[key])
        } else {
          url += `&${key}=${record[key]}`
        }
        this.$refs['iframeDrawer'].show(url)
      },
      videoModalFormOk () {
        this.videoModalShow = false
      },
      visibModal () {
        this.$refs.videoModal.leftList = this.deviceVideoList
        // this.$refs.videoModal.show({
        //   liveUrl: this.deviceVideoList?.[0].videoUrl ?? ''
        // })
        this.$refs.videoModal.show()
        this.$refs.videoModal.title = '视频'
        this.$refs.videoModal.disableSubmit = false
        this.videoModalShow = true
      }
    }
  }
</script>

<style lang="less" scoped>
  @import './index.less';

  .detail-layout {
    margin-left: 44px;
  }
  .page-header-title {
    display: flex;
    height: 40px;
    padding-top: 6px;
    .action-i {
      font-size: 22px;
      cursor: pointer;
    }
  }
  .text {
    color: rgba(0, 0, 0, 0.45);
  }
  .c-tabs {
    background: #fff;
    &-panel {
      min-height: 400px;
      &-head {
        font-size: 16px;
        font-weight: 700;
      }
    }
  }
  .device-img {
    width: 100px !important;
    height: 100px !important;
    border-radius: 0% !important;
  }
  ::v-deep {
    .content {
      position: relative;
      margin-top: 0px;
    }
    .page-header {
      border-bottom: none;
      .title {
        flex: none !important;
      }
      .action {
        text-align: left !important;
      }
    }
    .term {
      vertical-align: top;
    }
    .ant-descriptions-row {
      .ant-descriptions-item-label {
        vertical-align: inherit;
      }
      .ant-descriptions-item-content {
        vertical-align: inherit;
      }
    }
    .ant-upload.ant-upload-select-picture-card {
      height: 100px;
      width: 100px;
    }
    img {
      height: 40px;
      width: 40px;
    }
  }
</style>
